const itemRemoval = {
  namespaced: true,
  state: {
    itemToRemove: {},
    itemToRemoveType: "",
    showItemRemovalConfirmation: false,
    eRemoveItemType: {
      Offer: "OFFER",
      Negotiation: "NEGOTIATION",
      Location: "LOCATION",
      AdminAccess: "ADMIN_ACCESS",
      User: "USER",
      ActiveUser: "ACTIVE_USER",
      UnauthorisedAction: "UNAUTHORISED_ACTION",
      Rule: "RULE",
      UnconfirmedChanges: "UNCONFIRMED_CHANGES",
    },
    eChangesType: {
      GlobalPricing: "GLOBAL_PRICING",
      Offer: "OFFER",
      RelationshipManagement: "RELATIONSHIP_MANAGEMENT",
    },
    unsavedChangesRemovalConfirmed: false,
  },
  getters: {
    showItemRemovalConfirmation(state) {
      return state.showItemRemovalConfirmation;
    },
    eRemoveItemType(state) {
      return state.eRemoveItemType;
    },
    itemToRemove(state) {
      return state.itemToRemove;
    },
    unsavedChangesRemovalConfirmed(state) {
      return state.unsavedChangesRemovalConfirmed;
    },
    eChangesType(state) {
      return state.eChangesType;
    },
  },
  mutations: {
    OPEN_CONFIRMATION_REMOVAL: (state, payload) => {
      state.itemToRemove = payload.item || {};
      state.itemToRemoveType = payload.type || "";
      state.showItemRemovalConfirmation = payload.showWindow || false;
    },
    CONFIRM_UNSAVED_CHANGES_REMOVAL: (state, unsavedChangesRemovalConfirmed) => {
      state.unsavedChangesRemovalConfirmed = unsavedChangesRemovalConfirmed;
    },
  },
  actions: {
    openConfirmationRemoval: ({ commit }, payload) => {
      commit("OPEN_CONFIRMATION_REMOVAL", payload);
    },
    confirmUnsavedChangesRemoval: ({ commit }, unsavedChangesRemovalConfirmed) => {
      commit("CONFIRM_UNSAVED_CHANGES_REMOVAL", unsavedChangesRemovalConfirmed);
    },
  },
};

export default itemRemoval;